import React, { createContext, useContext, useState, useEffect } from 'react';

const EmployeeContext = createContext();

export const EmployeeProvider = ({ children }) => {
  const [employeeData, setEmployeeData] = useState([]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const authKey = localStorage.getItem('key');
        const companyId = localStorage.getItem('authToken');

        if (!authKey) {
          console.error('Key is missing!');
          return;
        }

        const formData = new FormData();
        formData.append('key', authKey);
        formData.append('cid', companyId);

        const response = await fetch(
          'https://app.mindstreamsoft.com/emp_directory.php',
          {
            method: 'POST',
            body: formData,
          }
        );

        const rawResponse = await response.text();
        let data;
        try {
          data = JSON.parse(rawResponse);
        } catch (err) {
          throw new Error('API returned invalid JSON.');
        }

        setEmployeeData(data);
      } catch (error) {
        console.error('Error fetching employees:', error);
      }
    };

    fetchEmployees();
  }, []);

  return (
    <EmployeeContext.Provider value={{ employeeData, setEmployeeData }}>
      {children}
    </EmployeeContext.Provider>
  );
};

export const useEmployeeData = () => {
  return useContext(EmployeeContext);
};
